module.exports = __webpack_public_path__ + "img/album21_16.76b689ed.jpg";